
































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { TbReport,TbOrderPad,TbPickupOrder } from "@/http";
import { calendarPanel, NumberKeyboard } from "@/components";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
import { fmoney } from "@/common/util/money";
import calculate from "@/common/util/calculate";
import deliveryDetail from "./deliveryDetail.vue";
dayjs.locale("zh-cn");
@Component({
  components: {
    calendarPanel,
    NumberKeyboard,
    deliveryDetail,
  },
})
export default class deliverybb extends Vue {
  public $refs: {
    detail: HTMLFormElement;
    calendar1: HTMLFormElement;
  };

  curZL = 1;
  fmoney = fmoney;
  dayjs = dayjs;
  /**查询项- */
  searchValue1 = {
    key: "",
    shopid: JSON.parse(localStorage.getItem("padShopInfo")).id,
    shopno: JSON.parse(localStorage.getItem("padShopInfo")).shopNo,
    start: dayjs(new Date()).format("YYYY-MM-DD") + " " + "00:00:00",
    end: dayjs(new Date()).format("YYYY-MM-DD") + " " + "23:59:59",
    skip: 0,
    count: 10,
  };
  searchValue2 = {
    key: "",
    startTime: dayjs(new Date()).format("YYYY-MM-DD") + " " + "00:00:00",
    endTime: dayjs(new Date()).format("YYYY-MM-DD") + " " + "23:59:59",
    skip: 0,
    count: 10,
  };
  /**时间类型下拉 */
  showStatusPopover = false;
  payType = null;
  payOptions = [
    {
      label: "全部支付方式",
      value: null,
    },
    {
      label: "会员卡支付",
      value: 1,
    },
    {
      label: "现金支付",
      value: 2,
    },
    {
      label: "微信支付",
      value: 3,
    },
    {
      label: "支付宝支付",
      value: 4,
    },
    {
      label: "现金+会员卡+微信",
      value: 5,
    },
    {
      label: "现金+会员卡+支付宝",
      value: 6,
    },
    {
      label: "现金+微信",
      value: 7,
    },
    {
      label: "现金+支付宝",
      value: 8,
    },
    {
      label: "会员卡+微信",
      value: 9,
    },
    {
      label: "会员卡+支付宝",
      value: 10,
    },
    {
      label: "现金+会员卡",
      value: 11,
    },
    {
      label: "线下微信",
      value: 13,
    },
    {
      label: "线下支付宝",
      value: 14,
    },
    {
      label: "现金+线下支付宝",
      value: 15,
    },
    {
      label: "会员卡+线下支付宝",
      value: 16,
    },
    {
      label: "现金+线下微信",
      value: 17,
    },
    {
      label: "会员卡+线下微信",
      value: 18,
    },
    {
      label: "线下微信+线下支付宝",
      value: 19,
    },
    {
      label: "现金+会员卡+线下支付宝",
      value: 20,
    },
    {
      label: "现金+会员卡+线下微信",
      value: 21,
    },
    {
      label: "现金+线下支付宝+线下微信",
      value: 22,
    },
    {
      label: "会员卡+线下支付宝+线下微信",
      value: 23,
    },
  ];
  payOptions2 = [
    {
      label: "全部退款方式",
      value: null,
    },
    {
      label: "线下",
      value: 1,
    },
    {
      label: "会员卡",
      value: 2,
    },
    {
      label: "线下+会员卡",
      value: 3,
    },
  ];
  payOptions3 = [
    {
      label: "全部支付方式",
      value: null,
    },
    {
      label: "微信支付",
      value: 3,
    },
    {
      label: "支付宝支付",
      value: 4,
    },
    {
      label: "会员卡支付",
      value: 1,
    },
    {
      label: "现金支付",
      value: 2,
    },
  ];

  /**支付状态下拉 */
  showzfStatusPopover = false;
  payStatusType = null;
  payStatusOptions = [
    {
      label: "支付状态",
      value: null,
    },
    {
      label: "支付失败",
      value: 3,
    },
    {
      label: "已关闭",
      value: 4,
    },
  ];

  /**时间控件 */
  pickerShow = false;
  startDate = dayjs(new Date()).format("YYYY-MM-DD");
  endDate = dayjs(new Date()).format("YYYY-MM-DD");

  /**列表展示
   * 1:图
   * 2：表格
   */
  showType = 1;

  userInfo: any = {};

  /**列表加载相关 */
  refreshing = false;
  loading = false;
  finished = false;
  list = [];
  list2 = [];
  list3 = [];
  total = 0;
  totalInfoNum = 0;
  totalPrice = 0;
  currentPage = 1;
  totalStock = 0;

  timeActive = null;
  hj_ze = "0.00";
  hj_xsnum = 0;
  hj_the = "0.00";
  hj_sxze = "0.00";
  hj_zkze = "0.00";

  hj_xjnovip = "0.00";
  hj_xj = "0.00";
  hj_cash = "0.00";
  hj_wechat = "0.00";
  hj_alipay = "0.00";
  hj_vipcard = "0.00";
  hj3_ze = "0.00";
  hj3_sxze = "0.00";
  hj3_czze = "0.00";
  iscz = false;

   defaultDate = [];

  get getPayStatus() {
    let str = "";
    str = this.payOptions.find((v) => v.value == this.payType).label;
    return str;
  }
  get getPayStatus2() {
    let str = "";
    str = this.payOptions2.find((v) => v.value == this.payType).label;
    return str;
  }
  get getPayStatus3() {
    let str = "";
    str = this.payOptions3.find((v) => v.value == this.payType).label;
    return str;
  }
  get getzfPayStatus() {
    let str = "";
    str = this.payStatusOptions.find((v) => v.value == this.payStatusType).label;
    return str;
  }

  @Watch("searchValue1.key")
  nameChange(val) {
    if (!this.iscz) {
      this.getList();
    }
  }
  @Watch("searchValue2.key")
  nameChange3(val) {
    if (!this.iscz) {
      this.getList();
    }
  }

  created() {}

  async mounted() {
    this.userInfo = JSON.parse(localStorage.getItem("padUserinfo"));
    // window.webkit.messageHandlers.getFocus.postMessage('getFocus');
    document.addEventListener('click',this.chargeInputFocus)

        window["scanInput"] = async (val) => {
            await this.scanInput(val);
        };

  }

  async scanInput(val){
         if(this.curZL==2){
          this.searchValue2.key=val;
        }
    }

    chargeInputFocus(event){
        if (event.target.tagName.toLowerCase() != 'input') {
            this.$nextTick(()=>{
                window.webkit.messageHandlers.getFocus.postMessage('getFocus');
            })
        }
    }
    beforeDestroy() {
        document.removeEventListener('click', this.chargeInputFocus)
    }

  chooseZL(tag) {
    this.curZL = tag;
    this.clearSearch();
    this.iscz = false;
    this.getList();
  }
  clearSearch() {
    switch (this.curZL) {
      case 1:
        this.searchValue1 = {
          key: "",
          shopid: JSON.parse(localStorage.getItem("padShopInfo")).id,
          shopno: JSON.parse(localStorage.getItem("padShopInfo")).shopNo,
          start: dayjs(new Date()).format("YYYY-MM-DD") + " " + "00:00:00",
          end: dayjs(new Date()).format("YYYY-MM-DD") + " " + "23:59:59",
          skip: 0,
          count: 10,
        };
        break;
      case 2:
        this.searchValue2 = {
          key: "",
          startTime: dayjs(new Date()).format("YYYY-MM-DD") + " " + "00:00:00",
          endTime: dayjs(new Date()).format("YYYY-MM-DD") + " " + "23:59:59",
          skip: 0,
          count: 10,
        };
        break;
      default:
        break;
    }
    this.timeActive = null;
    this.startDate = dayjs(new Date()).format("YYYY-MM-DD");
    this.endDate = dayjs(new Date()).format("YYYY-MM-DD");
  }

  openselDate() {
    if(this.startDate&&this.endDate){
        let start = new Date(this.startDate);
        let end = new Date(this.endDate);
        let defaultDate = [start,end];
        this.defaultDate = defaultDate;
    }else{
        let start = new Date();
        let end = new Date();
        let defaultDate = [start,end];
        this.defaultDate = defaultDate;
    }
    this.pickerShow = true;
  }
  /**确定选择时间 */
  onselConfirm(date) {
    const [start, end] = date;
    this.startDate = dayjs(start).format("YYYY-MM-DD");
    this.endDate = dayjs(end).format("YYYY-MM-DD");

    this.pickerShow = false;
    this.timeActive = null;
    this.setTimeSearch();
  }
  closeTime() {
    this.pickerShow = false;
  }

  /**下拉刷新 */
  onRefresh() {
    // 清空列表数据
    this.finished = false;
    // 重新加载数据
    // 将 loading 设置为 true，表示处于加载状态
    this.loading = true;
    let arg =
      this.curZL == 1
        ? "searchValue1"
        : this.curZL == 2
        ? "searchValue2"
        : "searchValue1";
    this[arg].skip = 0;
    this[arg].count = 10;
    this.currentPage = 1;
    this.loadMore();
  }
  /**触底加载 */
  async loadMore() {
    let arg =
      this.curZL == 1
        ? "searchValue1"
        : this.curZL == 2
        ? "searchValue2"
        :"searchValue1";
    let arg2 =
      this.curZL == 1
        ? "list"
        : this.curZL == 2
        ? "list2"
        : "list";
    if (this.refreshing) {
      this[arg2] = [];
      this.refreshing = false;
    }
    let s = this[arg].count;
    switch (this.curZL) {
      // 销售订单
      case 1:
        let resjy = await TbPickupOrder.GetTbPickupOrderList(Object.assign({}, this[arg]));
        this.list =
          this[arg].skip == 0
            ? resjy.items
            : this.list.concat(
                resjy.items
              );
        this.total = resjy.totalCount;
        this.totalInfoNum = resjy.totalInfoNum;
        this.totalPrice = resjy.totalPrice;
        this.iscz = false;
        break;
      // 退货订单
      case 2:
        let reszf = await TbPickupOrder.GetTbPickupOrderReportList(Object.assign({}, this[arg]));
        this.list2 =
          this[arg].skip == 0
            ? reszf.items
            : this.list2.concat(
                reszf.items.map
              );
        this.total = reszf.totalCount;
        this.totalInfoNum = reszf.totalInfoNum;
        this.totalPrice = reszf.totalPrice;
        this.iscz = false;
        break;
      
      default:
        break;
    }
    this.currentPage++;
    this[arg].skip = (this.currentPage - 1) * s;
    this.loading = false;
    if (this[arg2].length >= this.total) {
      this.finished = true;
    }
  }
  /**获取商品列表 */
  async getList() {
    this.onRefresh();
  }
  /**重置 */
  resetSearch() {
    switch (this.curZL) {
      case 1:
        this.searchValue1 = {
          key: "",
          shopid: JSON.parse(localStorage.getItem("padShopInfo")).id,
          shopno: JSON.parse(localStorage.getItem("padShopInfo")).shopNo,
          start: dayjs(new Date()).format("YYYY-MM-DD") + " " + "00:00:00",
          end: dayjs(new Date()).format("YYYY-MM-DD") + " " + "23:59:59",
          skip: 0,
          count: 10,
        };
        break;
      case 2:
        this.searchValue2 = {
          key: "",
          startTime: dayjs(new Date()).format("YYYY-MM-DD") + " " + "00:00:00",
          endTime: dayjs(new Date()).format("YYYY-MM-DD") + " " + "23:59:59",
          skip: 0,
          count: 10,
        };
        break;
      default:
        break;
    }
    this.timeActive = null;
    this.startDate = dayjs(new Date()).format("YYYY-MM-DD");
    this.endDate = dayjs(new Date()).format("YYYY-MM-DD");
    console.log(1);
    this.iscz = true;
    this.getList();
  }

  async chooseTime(type) {
    this.timeActive = type;
    // 获取当前日期
    const today = dayjs();
    const firstDayOfWeek = dayjs().startOf("week");
    const firstDayOfMonth = dayjs().startOf("month");
    const prevMonthStart = today.subtract(1, "month").startOf("month");
    const prevMonthEnd = today.subtract(1, "month").endOf("month");
    switch (type) {
      case 1:
        this.startDate = today.format("YYYY-MM-DD");
        this.endDate = today.format("YYYY-MM-DD");
        break;
      case 2:
        this.startDate = firstDayOfWeek.format("YYYY-MM-DD");
        this.endDate = today.format("YYYY-MM-DD");
        break;
      case 3:
        this.startDate = firstDayOfMonth.format("YYYY-MM-DD");
        this.endDate = today.format("YYYY-MM-DD");
        break;
      case 4:
        this.startDate = prevMonthStart.format("YYYY-MM-DD");
        this.endDate = prevMonthEnd.format("YYYY-MM-DD");
        break;

      default:
        break;
    }
    await this.setTimeSearch();
  }
  async setTimeSearch() {
    switch (this.curZL) {
      case 1:
        this.searchValue1.start = this.startDate ? this.startDate + " 00:00:00" : "";
        this.searchValue1.end = this.endDate ? this.endDate + " 23:59:59" : "";
        break;
      case 2:
        this.searchValue2.startTime = this.startDate ? this.startDate + " 00:00:00" : "";
        this.searchValue2.endTime = this.endDate ? this.endDate + " 23:59:59" : "";
        break;
      default:
        break;
    }
    this.iscz = false;
    await this.getList();
  }
  viewdetail(item) {
    this.$refs.detail.showFun(item);
  }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/report/components/deliverybb.vue